import { render, staticRenderFns } from "./CustomFadeIn.vue?vue&type=template&id=5ae448b0&scoped=true&"
import script from "./CustomFadeIn.vue?vue&type=script&lang=js&"
export * from "./CustomFadeIn.vue?vue&type=script&lang=js&"
import style0 from "./CustomFadeIn.vue?vue&type=style&index=0&id=5ae448b0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae448b0",
  null
  
)

export default component.exports